export default {
        firstToCreate: 'كن أول من ينشئ موضوعًا في هذا المنتدى',
        firstToPostInCategory: 'كن أول من ينشر في هذه الفئة',
        firstToRespondToTopic: 'كن أول من يرد على هذا الموضوع!',
        createNewThread: 'إنشاء موضوع جديد',
        thread: 'موضوع',
        viewThread: 'عرض الموضوع',
        replies: 'الردود',
        noReplies: 'لا توجد ردود',
        reply: 'رد',
        _reply: 'رد',
        ReplyTo: 'الرد على',
        replyToThisQuestion: 'الرد على هذا السؤال',
        onceRepliedModeratorMayRespond: 'بعد أن ترد، قد يرد مشرف المنتدى على ردك',
        onceRepliedCanViewResponses: 'بعد أن ترد يمكنك عرض ردود المشاركين الآخرين',
        loadingResponses: 'جارٍ تحميل الردود',
        hideXReplies: 'إخفاء {count} ردود',
        showXReplies: 'عرض {count} ردود',
        hideMostRecentReplies: 'إخفاء أحدث الردود',
        showMostRecentReplies: 'عرض أحدث الردود',
        post: 'نشر',
        message: 'رسالة',
        typeMessage: 'اكتب رسالة',
        addPost: 'إضافة منشور',
        addMessage: 'إضافة رسالة',
        editPost: 'تعديل المنشور',
        editPostWithMedia: 'تعديل المنشور مع الوسائط',
        createPostWithMedia: 'إنشاء منشور مع الوسائط',
        deleteMessage: 'حذف الرسالة',
        deleteMessageConfirm: 'هل أنت متأكد أنك تريد حذف هذه الرسالة',
        pinPost: 'تثبيت المنشور',
        media: 'وسائط',
        uploadMedia: 'رفع وسائط',
        categories: 'الفئات',
        goBack: 'رجوع',
        goBackPrevious: 'العودة إلى الصفحة السابقة',
        goBackToCategory: 'العودة إلى فئة {name}',
        loadingLatestThreads: 'جارٍ تحميل أحدث المواضيع',
        loadingDiscussionForum: 'جارٍ تحميل منتدى النقاش',
        dontShowAgainForTask: 'عدم الإظهار مرة أخرى لهذه المهمة',
        title: 'العنوان',
        beTheFirst: 'كن أول من يرد على هذا الموضوع'
};
